import React from 'react';
import { publish } from './../../lib/events';

export const PlayerAddButton = ({option, releaseId, trackId, tracks, size}) => {
    const tracks_parsed = JSON.parse(tracks);

    const handleClick = () => {
        publish('playlist:add', {
            'option'    : option,
            'release_id' : releaseId,
            'track_no'  : trackId,
            'tracks'    : tracks_parsed
        });
    }
    return (
        <div className={(option === 'play' ? 'play-button' : 'add-button') + (tracks_parsed.length > 0 ? '' : ' no-tracks') + (size == 'big' ? ' big' : '') } onClick={handleClick}>{option === 'play' ? 'Play' : ''}</div>
    );
}